import { createContext, useState, PropsWithChildren, useContext } from "react";

type TQuoteFormContext = {
    formStep: number;
    goNextStep: () => void;
    goPrevStep: () => void;
} | undefined;

const QuoteFormContext = createContext<TQuoteFormContext | undefined>(undefined);

export const QuoteFormProvider = ({ children }: PropsWithChildren) => {
    const [formStep, setFormStep] = useState(1);

    const value = {
        formStep,
        goNextStep: () => setFormStep((prev) => prev + 1),
        goPrevStep: () => setFormStep((prev) => (prev > 1 ? prev - 1 : 1)),
    };

    return (
        <QuoteFormContext.Provider value={value}>
            {children}
        </QuoteFormContext.Provider>
    );
};

// Custom Hook for Easy Access
export const useQuoteFormContext = () => {
    const context = useContext(QuoteFormContext);
    if (!context) {
        throw new Error("useQuoteForm must be used within a QuoteFormProvider");
    }
    return context;
};

export default QuoteFormProvider;